import { render } from "./OrderPaymentMethods.vue?vue&type=template&id=553f9bec&ts=true"
import script from "./OrderPaymentMethods.vue?vue&type=script&lang=ts"
export * from "./OrderPaymentMethods.vue?vue&type=script&lang=ts"

import "./OrderPaymentMethods.vue?vue&type=style&index=0&id=553f9bec&lang=scss"

import exportComponent from "D:\\YellowBeardProject\\bridge\\bridgeshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__